import { z } from 'zod';
import { zodOptional } from '@studio/utils/zod';
import { ZAsset } from './library-asset';
import { IMediaAsset } from '../element-asset';

export const ZImageLibraryAsset = z.object({
    id: z.string(),
    original: ZAsset,
    thumbnail: ZAsset,
    url: z.string().min(1),
    name: z.string(),
    created: z.string(),
    modified: zodOptional(z.string()),
    fileSize: z.number(),
    height: z.number(),
    width: z.number()
});
export type ImageLibraryAsset = z.infer<typeof ZImageLibraryAsset>;

export const ZImageFileUploadDto = ZImageLibraryAsset.pick({
    thumbnail: true,
    original: true
});
export type ImageFileUploadDto = z.infer<typeof ZImageFileUploadDto>;
export type CreateImageAssetResult = { createImageAsset: CreateImageAssetDto };
export interface ICreateImageVariables {
    image: {
        name: string;
        fileSize: number;
        original: IMediaAsset;
        thumbnail: IMediaAsset;
    };
}
export const ZImageLibraryAssetDto = ZImageLibraryAsset.omit({
    width: true,
    height: true,
    url: true
});

export interface CreateImageAssetDto extends z.infer<typeof ZImageLibraryAssetDto> {}
